
import { computed, defineComponent } from 'vue';
import CustomerCouponDetail from '@/components/organisms/coupon/CustomerCouponDetail.vue';
import CouponDescription from '@/components/organisms/coupon/content/CouponDescription.vue';
import CouponAvailableShops from '@/components/organisms/coupon/content/CouponAvailableShops.vue';

export default defineComponent({
  name: 'DialogCustomerCouponDetail',

  components: {
    CustomerCouponDetail,
    CouponDescription,
    CouponAvailableShops,
  },

  model: {
    prop: 'dialog',
  },

  props: {
    customerCoupon: {
      type: Object,
      required: true,
    },
    restriction: {
      type: String,
      required: false,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const used = computed(() => {
      try {
        return JSON.parse(props.customerCoupon.used) || false;
      } catch {
        return false;
      }
    });

    const endImageUrl = computed(() => {
      try {
        return JSON.parse(props.customerCoupon.couponMaster.attrs).endImageUrl || null;
      } catch {
        return null;
      }
    });

    return { used, endImageUrl };
  },
});
